<template lang="html">
  <div class="feladatleiras">
    <v-row>
      <div v-if="$route.query.mode" class="selectBack" @click="selectOther">
        Mást választok!<v-icon>mdi-arrow-down</v-icon>
      </div>
    </v-row>

    <div class="leiras" v-if="gameMode=='readSoroban'">
      <h1 class="text-center">Mennyit mutat a soroban? <v-icon class="ml-3" @click="toggleDescription">mdi-eye</v-icon></h1>
      <p>
        Kérd a számot, és olvasd le! Írd be a gombokkal! Ha jól számoltál, tiéd a maci!<br/>
        A sorobant most nem tudod irányítani, a billentyűzet a tiéd. A szám melletti kukára kattintva törölheted az addig beírt számot, ha elrontottad.
      </p>
    </div>

    <div class="leiras" v-if="gameMode=='moveSoroban'">
      <h1 class="text-center">Hogy néz ki ez a szám a sorobanon? <v-icon class="ml-3" @click="toggleDescription">mdi-eye</v-icon></h1>
      <p>
        Kérd a számot, és állítsd be a sorobanon! Ha jól csináltad, tiéd a maci!<br/>
        A gyöngyöket kattintással tudod mozgatni. Segítségként mutatjuk, éppen hol tartasz.
      </p>
    </div>

    <div class="leiras" v-if="gameMode=='complements'">
      <h1 class="text-center">Komplementerek<v-icon class="ml-3" @click="toggleDescription">mdi-eye</v-icon></h1>
      <p>
        Mi a komplementere? Oszd le a kártyákat, és kattints rájuk, hogy ellenőrizd magad!
      </p>
    </div>

    <div v-if="gameMode!=null">
      <h3>{{level}}. szint
      <v-icon @click="$store.dispatch('kids/levelUp')">mdi-arrow-up</v-icon>
      <v-icon @click="$store.dispatch('kids/levelDown')">mdi-arrow-down</v-icon>
      </h3>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  data(){
    return {
      showDescription : true,
    }
  },
  computed:{
    gameMode(){
      return this.$store.getters['kids/gameMode']
    },
    level(){
      return this.$store.getters['kids/level']
    }
  },
  methods:{
    selectOther(){
      this.$router.push({name:'kids'})
      this.$store.dispatch('kids/setGameMode',null)
    },
    toggleDescription(){
      const timeline = gsap.timeline()
      if (this.showDescription) {
        timeline.to('.leiras p', {duration:1, y:-10, opacity:0, display: 'none'})
      }else{
        timeline.to('.leiras p', {duration:1, y:0, opacity:1, display: 'block'})
      }
      this.showDescription = !this.showDescription;
    }
  },
  watch:{
    gameMode(){
      this.showDescription = true;
    }
  },
  updated(){


  }
}
</script>

<style lang="scss" scoped>
.v-application p{
  font-size: 1.2rem;
}

.selectBack{
  margin-left: 10px;
}
.selectBack,
.selectBack .mdi-arrow-down{
  color: blue;
}

.selectBack:hover,
.selectBack:hover .mdi-arrow-down{
  color: indigo;
  cursor: pointer;
}

</style>
